import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React, { useState } from 'react';

const VisualizarServicoTable = ({ servicos, styles}) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }} className="mb-16">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" className={styles.cellServicos}>
                Nome do serviço
              </TableCell>
              <TableCell align="right">Valor (R$)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {servicos?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((s) => (
              <TableRow key={s?.id}>
                <TableCell component="th" align="left">
                  {s.servico?.descricao}
                </TableCell>
                <TableCell align="right">{getCurrency(s?.valor).replace('R$', '')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {servicos?.length > 5 && (
          <TablePagination
            component="div"
            className="pb-0"
            count={servicos?.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage={false}
            page={page}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            onChangePage={handleChangePage}
            rowsPerPageOptions={[]}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default VisualizarServicoTable;
